import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {WGGameConfig} from "../../../WGGameConfig";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TimelineMax, TweenLite} from "gsap"
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {WGEngineManager} from "../../../engine/WGEngineManager";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {WGSpriteSymbol} from "../../../engine/Symbol/WGSpriteSymbol";
import {SoundManager} from "../../../resource/sound/SoundManager";
import {WGSoundConfig} from "../../../WGSoundConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {WgShakingDisplayObject} from "../../../DisplayObject/WgShakingDisplayObject";
import {WarriorGraveyardGameModuleConfig} from "../../../WarriorGraveyardGameModuleConfig";

export class WarriorFeatureEvents {
    public static readonly SPIN_AWAY_ALIVE_SYMBOL_ANIM: string = "warriorFeatureEvents_spin_away_alive_m_symbol";

}

export class WarriorPayfeatureView extends BaseView {

    public _activeWarriorReels: boolean[] = [];
    private _graphics: PIXI.Graphics;
    public wildMultipliers: number[];
    private _actualWarriorSymbolPos: number[] = [];
    public _triggeredWarriorSymbol: string = "";
    public _mulitplierDisplayed: boolean = false;
    public _stickyWildReels: boolean[] = [];
    private stepDistanceY: number = 198;
    public _movementPresent: boolean = false;
    public _isSoundAborted = false;
    private _deadSymbol: PIXI.Sprite[] = [];
    public _deadToAliveTransition: PIXI.spine.Spine[] = [];
    // Multiplier items
    private _warriorMultiplierContainer: PIXI.Container[] = [];
    public _warriorMultiplieronSymbols: number[] = [1, 1, 1, 1, 1, 1];
    private _x: number = 0;
    public _warriorMulitplierGlow: TimelineSprite[] = [];
    public tlCount: TimelineMax;
    public shakingObject: WgShakingDisplayObject;


    /**
     * override this to create M Symbol Animation when assets are loaded
     */
    protected initAnimations(): void {
        this.tlCount = new TimelineMax();
        this.shakingObject = new WgShakingDisplayObject(StageManager.stage);
        StageManager.getLayer(WGGameConfig.instance.LAYERS.STICKY.name).addChild(this);
        this.createMaskForstackSymbol();
        this.createWarriorMulitplierContainers();
        this.createMSymbolAliveAnimation();
        this._warriorMultiplierContainer.forEach((container: PIXI.Container, index: number) => {
            container.pivot.set(container.width * 2, container.height);
        });
        this.onResize();
    }

    /**
     * warrior moving follow smoke
     */
    private createWarriorSmoke(): PIXI.Sprite {
        const warriorSmoke = new PIXI.Sprite(GameResources.getTextures("warriorSmoke")[0]);
        warriorSmoke.anchor.set(0, 0.5);
        warriorSmoke.mask = this._graphics;
        warriorSmoke.position.y = 199 * 2;
        warriorSmoke.blendMode = PIXI.BLEND_MODES.ADD;
        warriorSmoke.visible = false;
        this.addChildAt(warriorSmoke, 0);
        return warriorSmoke;
    }

    private createSlamParticleAnim(reelId: number): TimelineSprite {
        const warriorSlamParticles = new TimelineSprite(GameResources.getTextures("warriorSlamParticles"), 30);
        warriorSlamParticles.blendMode = PIXI.BLEND_MODES.ADD;
        warriorSlamParticles.anchor.set(0, 0.5);
        warriorSlamParticles.position.set(120 * (reelId + 1) - (warriorSlamParticles.width * 0.85), 190 * 2);
        warriorSlamParticles.visible = false;
        this.addChild(warriorSlamParticles);
        return warriorSlamParticles;
    }

    private createTopAndBottomSmokePuff(): TimelineSprite[] {
        let topAndBottomSmokePuff: TimelineSprite[] = [];
        const topAnim = new TimelineSprite((GameResources.getTextures("warriorTopAndBottomPuff")), 30);
        const bottomAnim = new TimelineSprite((GameResources.getTextures("warriorTopAndBottomPuff")), 30);
        topAnim.anchor.set(0.5);
        bottomAnim.anchor.set(0.5);
        topAnim.position.set(0, 30);

        bottomAnim.position.set(0, 190 * 3.9)
        bottomAnim.scale.y *= -1;
        topAndBottomSmokePuff.push(topAnim, bottomAnim);
        topAndBottomSmokePuff.forEach(value => value.visible = false);
        this.addChild(topAnim, bottomAnim);
        return topAndBottomSmokePuff;
    }

    private createHitFire() {
        const warriorHitFire = new PIXI.Sprite(GameResources.getTextures("warriorHitFire")[0]);
        warriorHitFire.anchor.set(0.5, 0.5)
        warriorHitFire.blendMode = PIXI.BLEND_MODES.SCREEN;
        warriorHitFire.visible = false;
        warriorHitFire.mask = this._graphics;
        warriorHitFire.position.y = 190 * 2
        this.addChild(warriorHitFire);
        return warriorHitFire;
    }

    /**
     * function to create wil multiplier container for middle reels
     * all containers of each reel has a single parent container.
     */
    private createWarriorMulitplierContainers(): void {
        for (let i: number = 0; i < WGGameConfig.instance.REEL_ENGINE_CONFIG.REEL_AMOUNT; i++) {
            let multiplierContainer: PIXI.Container = new PIXI.Container();
            this._warriorMultiplierContainer.push(multiplierContainer);
            const xImage = new PIXI.Sprite(GameResources.getTextures("mult_fr_x")[0]);
            const imageOne = new PIXI.Sprite(GameResources.getTextures("mult_fr_1")[0]);
            multiplierContainer.visible = false;
            multiplierContainer.scale.set(0.3);
            multiplierContainer.addChild(xImage);

            this._x = (multiplierContainer.children[multiplierContainer.children.length - 1].x + (multiplierContainer.children[multiplierContainer.children.length - 1] as PIXI.Sprite).width) - 10;
            multiplierContainer.addChild(imageOne);
            imageOne.x = this.x;
            const glowAnim: TimelineSprite = new TimelineSprite(GameResources.getTextures("wildMultiplierGlow"));
            glowAnim.blendMode = PIXI.BLEND_MODES.ADD;
            glowAnim.anchor.set(0.5);
            glowAnim.visible = false;
            glowAnim.scale.set(0.8);
            this._warriorMulitplierGlow.push(glowAnim);
            this.addChild(glowAnim, multiplierContainer);
        }
    }

    /**
     * function to do stuff on each nudge step completed, particularly increasing multiplier
     * @param reelId
     */
    public nudgeStepCompleted(reelId: number, showMultiplierOnly: boolean = false) {
        this._deadSymbol[reelId].visible = true;
        const container = this._warriorMultiplierContainer[reelId];
        const multiplier = showMultiplierOnly ? 1 : ++this._warriorMultiplieronSymbols[reelId];
        const multiplierNum = new PIXI.Sprite(GameResources.getTextures("mult_fr_" + (multiplier).toString())[0]);

        if (!container.visible) {
            container.visible = true;
            this._mulitplierDisplayed = true;
            container.position.set((120 * reelId) + 45, 199 * 2.1);
        }
        const glowAnim: TimelineSprite = this._warriorMulitplierGlow[reelId];
        container.children.length > 1 && container.removeChildAt(1);
        multiplierNum.position.x = this._x;
        container.addChild(multiplierNum);

        glowAnim.position.set(container.position.x + 20, container.position.y);
        this.tlCount.to(container.scale, 0.05, {x: 0.4, y: 0.4}, this.tlCount.time());
        this.tlCount.add(glowAnim.getAnimationAutoShowHide(true, true), this.tlCount.time());
        this.tlCount.to(container.scale, 0.05, {x: 0.3, y: 0.3}, this.tlCount.time() + 0.05);

    }

    /**
     * function to create M symbol ALive ANimation for all M Stack and for all reel Id's
     */
    public createMSymbolAliveAnimation(): void {
        this._deadToAliveTransition = [];
        this._deadSymbol = [];

        for (let i: number = 0; i < WGGameConfig.instance.REEL_ENGINE_CONFIG.REEL_AMOUNT; i++) {
            const deadSymbol = new TimelineSprite(GameResources.getTextures(`M1_dead`));
            deadSymbol.anchor.set(0.5, 0.5);
            deadSymbol.position.set((WGGameConfig.instance.REEL_ENGINE_CONFIG.DIM.WIDTH * i) + 120 / 2,
                90 + deadSymbol.height / 2);
            (deadSymbol as PIXI.DisplayObject).mask = this._graphics;
            this._deadSymbol.push(deadSymbol);
            deadSymbol.visible = false;
            this.addChild(deadSymbol);

            const deadToAliveTransition = new PIXI.spine.Spine(GameResources.getSpineAsset("midSymbolTransition"));
            deadToAliveTransition.visible = false
            deadToAliveTransition.position.set((WGGameConfig.instance.REEL_ENGINE_CONFIG.DIM.WIDTH * i) + 120 / 2,
                90 + deadSymbol.height / 2);
            this._deadToAliveTransition.push(deadToAliveTransition);
            new SpineTween(deadToAliveTransition, 0, "mid_alive_transition");
            this.addChild(deadToAliveTransition);

            this.addChild(this._warriorMulitplierGlow[i]);
            this.addChild(this._warriorMultiplierContainer[i]);
        }
    }

    /**
     * hide M SymbolAnimation when spin start
     */
    protected addEventListeners(): void {
        EventHandler.addEventListener(this, WarriorFeatureEvents.SPIN_AWAY_ALIVE_SYMBOL_ANIM, (event: GameEvent) => {
            if (event.params[0] === 0) {
                this.hideAllMstackSymbols();
            }
        });
        EventHandler.addEventListener(this, "HIDE_M_STACKS", (event: GameEvent) => {
            this.hideAllMstackSymbols(event.params[0]);
        });
        EventHandler.addEventListener(this, "SHOW_MID_STACKS_TOGGLE", (event: GameEvent) => {
            this.showMidStackToggle();
        });
    }

    private showMidStackToggle(): void {
        for (let i: number = 0; i < this._deadSymbol.length; i++) {
            if (this._deadSymbol[i].visible && this._deadSymbol[i].alpha === 0) {
                TweenLite.to(this._deadSymbol[i], 0.2, {alpha: 1});
                TweenLite.to(this._warriorMultiplierContainer[i], 0.2, {alpha: 1});
            }
        }
    }

    private hideAllMstackSymbols(willToggleLater: boolean = false): void {
        this._mulitplierDisplayed = false;
        if (this._triggeredWarriorSymbol.length) {
            this._deadSymbol.forEach(value => {
                TweenLite.fromTo(value, 0.5, {alpha: 1}, {
                    alpha: 0, onComplete: () => {
                        if (!willToggleLater) {
                            value.visible = false;
                            value.alpha = 1;
                        }

                    }
                });
            });
        }

        this._warriorMultiplierContainer.forEach((container: PIXI.Container, index: number) => {
            TweenLite.fromTo(container, 0.5, {alpha: 1}, {
                alpha: 0, onComplete: () => {
                    if (!willToggleLater) {
                        container.visible = false;
                        container.alpha = 1;
                        this.onResize();
                        this._deadSymbol.forEach(value => this.removeChild(value));
                        this._deadToAliveTransition.forEach(value => this.removeChild(value));
                        this._deadSymbol = [];
                        this._deadToAliveTransition = [];
                    }
                }
            });
        });
    }

    /**
     * mask create for reel area, when M symbol will spin away and will nowt show above the reel Area
     */
    private createMaskForstackSymbol(): void {
        this._graphics = new PIXI.Graphics();
        this._graphics.beginFill(0xFF3300);
        this._graphics.drawRect(-3, 90, 780, 594);
        this._graphics.endFill();
        this.addChild(this._graphics);
    }

    /**
     * function to play M Symbol Animation
     * @param reelId
     */
    public playMSymbolAliveAnimation(reelId: number, symName: string, steps: number): TimelineLite {
        const symbol: PIXI.Sprite = this._deadSymbol[reelId];
        const deadToALiveTransition = this._deadToAliveTransition[reelId];
        deadToALiveTransition.skeleton.setSkinByName(`${symName.toLowerCase()}_transition`);
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => WarriorGraveyardGameModuleConfig.anticipationAnimation.hideAllWarriorFire());
        tl.add(() => WarriorGraveyardGameModuleConfig.anticipationAnimation.stopAllWildLanding());
        tl.add(new SpineTween(deadToALiveTransition, 0, "mid_alive_transition"));
        tl.add(() => {
            deadToALiveTransition.updateTransform();
            deadToALiveTransition.visible = true;
        }, 0.01)
        tl.add(() => {
            if (symName === "M1") symbol.anchor.x = 0.545;
            symbol.texture = symbol.texture = GameResources.getTextures(`${symName.toUpperCase()}_alive`)[0];
        }, 0.2);

        return tl;
    }

    public showOverlayOfStackSymbolAnimationBeforeNudge(reelId: number, symName: string, steps: number): void {
        steps = steps > 0 ? -steps : Math.abs(steps);
        const symbol: PIXI.Sprite = this._deadSymbol[reelId];
        symbol.texture = GameResources.getTextures(`${symName}_dead`)[0];
        symbol.position.y += this.stepDistanceY * steps;
        symbol.position.x = (WGGameConfig.instance.REEL_ENGINE_CONFIG.DIM.WIDTH * reelId) + 120 / 2;
        symbol.visible = true;
    }

    /**
     * calculating which reelANimation will went to which reel index
     * @param symbolName
     */
    private calculateMSymbolMovingPositions(symbolName: string): any {
        this._actualWarriorSymbolPos = [];
        let reelsHavingAliveAnim: any = this._activeWarriorReels;
        this._activeWarriorReels.forEach((value: boolean, index: number) => {
            if (value) {
                this._actualWarriorSymbolPos.push(index);
            } else if ((!value && this.wildMultipliers[index]) || this._stickyWildReels[index]) {
                reelsHavingAliveAnim[index] = undefined;
            }
        });
        return reelsHavingAliveAnim;
    }

    /**
     * move m symbols from animating reel to left positioning reels.
     * @param symbolName
     */
    public moveMSymbolsToDesiredPositions(symbolName: string): TimelineLite {
        const reelsHavingAliveAnim: any = this.calculateMSymbolMovingPositions(symbolName);
        let tl: TimelineLite = new TimelineLite();
        let startDelay: number = 0;
        for (let i: number = 0; i < WGGameConfig.instance.REEL_ENGINE_CONFIG.REEL_AMOUNT; i++) {
            if (reelsHavingAliveAnim[i]) {
                this._movementPresent = true;
                let symbol: PIXI.Sprite = this._deadSymbol[i];
                let index = reelsHavingAliveAnim.indexOf(false);
                if (index > -1 && index < i) {
                    const warriorSmoke = this.createWarriorSmoke();
                    const warriorSlamParticles = this.createSlamParticleAnim(index);
                    const warriorHitFire = this.createHitFire();
                    const warriorHitFire1 = this.createHitFire();
                    warriorHitFire1.alpha = 0.5;
                    let topBottomPuff = this.createTopAndBottomSmokePuff();
                    // smoke follow anim show after a movement
                    tl.add(() => {
                        if (!warriorSmoke.visible) warriorSmoke.visible = true;
                        !this._isSoundAborted && SoundManager.playSoundEffect(WGSoundConfig.instance.WARRIOR_MOVING_LEFT);
                    }, startDelay + 0.03);
                    let posX = 15;
                    if (symbolName === "M1") {
                        posX = 0;
                    }
                    // to move symbol from right to left
                    tl.fromTo(symbol, 0.15,
                        {x: symbol.x},
                        {
                            x: (WGGameConfig.instance.REEL_ENGINE_CONFIG.DIM.WIDTH * index) + 120 / 2,
                            ease: CustomEase.create("warriorEase", "M0,0,C0.012,0.017,0.276,0.262,0.506,0.548,0.648,0.725,0.8,1,0.8,1,0.902,0.94,1,1,1,1"),
                            onUpdate: () => {
                                this._warriorMultiplierContainer[i].position.x = Helper.copyLocalPosition(this._warriorMultiplierContainer[i], symbol).x - posX;
                                warriorSmoke.position.x = (symbol.x + 120 / 2) - 50;
                            },
                            onComplete: () => {
                                this._warriorMultiplierContainer[i].position.x = Helper.copyLocalPosition(this._warriorMultiplierContainer[i], symbol).x - posX;
                                warriorSlamParticles.position.x = (120 * index) - 30;
                            }
                        }, startDelay);
                    // top and bottom puff
                    tl.add(() => {
                        warriorHitFire.position.x = (WGGameConfig.instance.REEL_ENGINE_CONFIG.DIM.WIDTH * index) + 50;
                        warriorHitFire.visible = true;
                        warriorHitFire1.position.x = (WGGameConfig.instance.REEL_ENGINE_CONFIG.DIM.WIDTH * index) + 50;
                        warriorHitFire1.visible = true;
                        this.shakingObject.warriorAttackShake(0.05, 2);
                        topBottomPuff.forEach(value => {
                            value.position.x = ((WGGameConfig.instance.REEL_ENGINE_CONFIG.DIM.WIDTH * index) + 120 / 2) - 50;
                            value.getAnimationAutoShowHide(true, true);
                        }, startDelay - 0.2);
                    });
                    // particles over symbols
                    tl.add(() => {
                        warriorSlamParticles.getAnimationAutoShowHide(true, true, [0], () => {
                            },
                            () => {
                                warriorHitFire.visible = false;
                                warriorHitFire1.visible = false;
                            });
                    });
                    // warrion smoke follow scale
                    tl.fromTo(warriorSmoke.scale, 0.1,
                        {x: warriorSmoke.scale.x},
                        {
                            x: 0,
                            onComplete: () => {
                                warriorSmoke.visible = false;
                                warriorSmoke.scale.x = 1;
                            }
                        }, startDelay + 0.15);
                    // single moving animaiton duration
                    startDelay = tl.duration() + 0.4;
                    reelsHavingAliveAnim[i] = false;
                    reelsHavingAliveAnim[index] = true;
                }
            }
        }
        tl.add(() => {
            if (this._movementPresent && this._isSoundAborted) {
                SoundManager.playSoundEffect(WGSoundConfig.instance.WARRIOR_MOVING_LEFT);
            }
        });
        return tl;
    }

    /**
     * function to nudge alive overlay
     * @param steps
     * @param reelId
     */
    public nudgeAliveSymbol(steps: number, reelId: number): TimelineLite {
        let tl: TimelineMax = new TimelineMax({
            onComplete: () => {
                symbol.position.y = Helper.copyLocalPosition(symbol, WGEngineManager.getReel(reelId).getSymbol(1) as WGSpriteSymbol).y;
            }
        });
        let stepDistance = steps > 0 ? this.stepDistanceY : -this.stepDistanceY;
        let symbol = this._deadSymbol[reelId];
        const yToPos: number = symbol.position.y;
        const bottomFire: TimelineSprite[] = WarriorGraveyardGameModuleConfig.anticipationAnimation._anticipationBotttomFire[reelId];
        const bottomFireYToPos: number = bottomFire[0].position.y;
        const easing: any = WGGameConfig.instance.REEL_ENGINE_CONFIG.EASING.NUDGE ? WGGameConfig.instance.REEL_ENGINE_CONFIG.EASING.NUDGE : WGGameConfig.instance.REEL_ENGINE_CONFIG.EASING.START;
        for (let s: number = 0; s < Math.abs(steps); s++) {
            tl.add(TweenLite.to(symbol.position, 0.2, {
                ease: easing,
                y: yToPos + (stepDistance * (s + 1))
            }), "+=" + 0.2);
            if (steps > 0) {
                for (let i = 0; i < bottomFire.length; i++) {
                    tl.add(() => {
                        TweenLite.to(bottomFire[i].position, 0.2, {
                            ease: easing,
                            y: bottomFireYToPos + (stepDistance * (s + 1))
                        });
                    }, "-=0.2");
                }
            }
            tl.add(() => {
                let symbolId: number = 0
                if (Math.abs(steps) === 2) {
                    symbolId = (steps === Math.abs(steps)) ? s + 1 : s === 1 ? 0 : s + 1;
                } else {
                    symbolId = (steps === Math.abs(steps))?2:0;
                }
                WarriorGraveyardGameModuleConfig.anticipationAnimation.playBorderFire(symbolId, reelId, false);
            });
            tl.add(() => {
                !this._isSoundAborted && SoundManager.playSoundEffect(WGSoundConfig.instance.WARRIOR_NUDGE);
            }, "-=" + 0.1);

            tl.add(() => this.nudgeStepCompleted(reelId));
        }
        return tl;
    }

    /**
     * override this function to handle stuff on resize.
     * @param resizeData
     */
    protected onResize(resizeData?: IResizeData): void {
        if (!this._mulitplierDisplayed) {
            this._warriorMultiplierContainer.forEach((container: PIXI.Container, index: number) => {
                container.position.set(120 * (index) + 45, 199 * 2.1);
            });
        }
    }
}